module.exports = __webpack_public_path__ + "images/tour/photos_choose_photos-729bc4a69f14b4a683579016c70aea09.gif";